// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3owZ6","title":"Info_title__Svof5","links":"Info_links__qqKYM","link":"Info_link__3e6LW","logo":"Info_logo__16VcB"};